<!--
 * @Descripttion:
 * @version: 优惠券-修改
 * @Author: Jeson
 * @Date: 2021-06-07 09:41:24
 * @LastEditors: Jeson
 * @LastEditTime: 2021-12-14 21:16:09
-->

<template>
  <div
    v-Clickoutside="handleClose"
    class="coupon"
    :style="{marginBottom:row?'25px':'10px'}"
  >
    <div
      class="top"
      :class="showDesc&&!row ? 'border-bottom' : ''"
    >
      <div
        class="left"
        :class="[item.IsOverdue||item.IsUse && !item.IsDestroy && !item.IsOverdue?'disabled':'',!item.IsReceive && !item.IsHasCoupon?'completely':'']"
      >
        <h3>
          <strong v-if="item.DeductionMode != 2">
            {{ item.DeductionMode == 1 ? item.DeductionLimit : '全' }}<em :class="[item.IsOverdue||item.IsUse && !item.IsDestroy && !item.IsOverdue?'icon-disabled':'',!item.IsReceive && !item.IsHasCoupon?'icon-completely':'']" /></strong>
          <strong v-if="item.DeductionMode == 2 && item.LimitF">{{ item.LimitF }}</strong>
          <strong v-if="item.DeductionMode == 2 && item.LimitL">{{ item.LimitL }}<em :class="['icon-discount',item.IsOverdue||item.IsUse && !item.IsDestroy && !item.IsOverdue?'icon-discount-disabled':'',!item.IsReceive && !item.IsHasCoupon?'icon-completely':'']" /></strong>
          <!-- <strong v-if="item.DeductionMode == 2">折</strong> -->
        </h3>
        <p v-if="item.UseRequire && item.UseRequire.GoodsLimitPrice">
          满{{ item.UseRequire.GoodsLimitPrice }}元可用
        </p>
        <p v-if="item.UseRequire && item.UseRequire.GoodsLimitNumber">
          满{{ item.UseRequire.GoodsLimitNumber }}元可用
        </p>
      </div>
      <div class="middle">
        <div>
          <h5>
            <span :class="[item.DeductionMode===1?'full-reduction':'discount',(item.IsUse && !item.IsDestroy && !item.IsOverdue)||item.IsOverdue?'disabled':'']">{{ item.DeductionMode===1?'满减券':'折扣券' }}</span>
            <template v-if="item.type==1">
              全场通用
            </template>
            <template v-if="item.type==2">
              原价商品可用
            </template>
            <template v-if="item.type==3">
              指定活动可用
            </template>
            <template v-if="item.type==4">
              指定商品可用
            </template>
            <template v-if="item.type==5">
              仅限购买【{{ _truncature((item.Goods && item.Goods[0].GoodsName) || '无名',18) }}】商品
            </template>
          </h5>
          <p
            v-if="item.OutCouponDto"
            class="date"
          >
            <template
              v-if="
                !item.OutCouponDto.OutCouponIssueDto.FailureDays ||
                  item.OutCouponDto.IsReceive
              "
            >
              有效期至：{{ item.OutCouponDto.ValidityEndTime || '' }}
            </template>
            <template v-else>
              {{
                `领取后${item.OutCouponDto.OutCouponIssueDto.FailureDays}天内有效`
              }}
            </template>
          </p>
          <p
            v-else
            class="date"
          >
            <template v-if="!item.OutCouponIssueDto.FailureDays || item.IsReceive">
              有效期至：{{ item.ValidityEndTime || '' }}
            </template>
            <template v-else>
              {{
                `领取后${item.OutCouponDto.OutCouponIssueDto.FailureDays}天内有效`
              }}
            </template>
          </p>
        </div>
        <div
          class="rule-show"
          @click="showDesc = !showDesc"
        >
          使用规则
          <span class="icon">
            <van-icon :name="showDesc ? 'arrow-up' : 'arrow-down'" />
          </span>
        </div>
        <img
          v-if="item.IsReceive && !item.IsUse&&!item.IsOverdue"
          class="tag-icon"
          src="../assets/mine/yilingqu.png"
          alt=""
        >
        <img
          v-if="!item.IsReceive && !item.IsHasCoupon"
          class="tag-icon"
          src="../assets/mine/yilingwan.png"
          alt=""
        >
        <img
          v-if="item.IsUse && !item.IsDestroy && !item.IsOverdue"
          class="tag-icon"
          src="../assets/mine/yishiyong.png"
          alt=""
        >
        <img
          v-if="item.IsOverdue"
          class="tag-icon"
          src="../assets/mine/yishixiao.png"
          alt=""
        >
      </div>
      <div
        v-if="!item.IsReceive && !item.IsHasCoupon"
        class="right disabled"
      >
        <span>已领完</span>
      </div>
      <div
        v-if="item.IsOverdue"
        class="right disabled"
      >
        <span>已失效</span>
      </div>
      <div
        v-if="item.IsUse && !item.IsDestroy && !item.IsOverdue"
        class="right disabled"
      >
        <span>已使用</span>
      </div>
      <div
        v-if="item.IsHasCoupon && !item.IsReceive"
        class="right"
        @click="handleCoupon(1,item)"
      >
        <span>立即领取</span>
      </div>
      <div
        v-if="
          !item.IsUse && !item.IsDestroy && !item.IsOverdue && item.IsReceive&&!item.Invalid
        "
        class="right isUse"
        @click="handleCoupon(2,item)"
      >
        <span>立即使用</span>
      </div>
    </div>
    <div
      v-show="showDesc"
      class="rule-desc"
      :class="row?'absolute':''"
    >
      <p>使用说明：<template v-if="item.UseRequire && item.UseRequire.GoodsLimitPrice">
        满{{ item.UseRequire.GoodsLimitPrice }}元可用
      </template>
        <template v-if="item.UseRequire && item.UseRequire.GoodsLimitNumber">
          满{{ item.UseRequire.GoodsLimitNumber }}元可用
        </template>
      </p>
      <p>
        使用权限：
        <!-- <template v-if="!item.Goods || !item.Goods.length">全场通用</template>
                <template v-else>仅限购买{{item.Goods.map((i)=>{return i.GoodsName}).join('、')}}</template>。 -->
        <template v-if="item.type==1">全场通用</template>
        <template v-if="item.type==2">原价商品可用</template>
        <template v-if="item.type==3">仅限购买指定活动中的商品</template>
        <template v-if="item.type==4||item.type==5">仅限购买：</template>
      </p>
      <p v-if="item.type==4||item.type==5">
        <template>{{ item.Goods.map((i)=>{return i.GoodsName?i.GoodsName:''}).join('、') }}</template>
      </p>
      <p v-if="(item.type==4||item.type==5)&&!item.IsUse">
        <template>
          <el-button
            type="primary"
            :loading="loading"
            style="border: none; color: #1E6BE0; background: none; cursor: pointer;"
            @click.stop="moreInfoBtn(item)"
          >查看详情</el-button>
        </template>
      </p>
      <p v-if="item.type==3">
        <template style="padding-left: 2px;"><span
          v-for="(t,index) in item.SpecialActivityList"
          :key="index"
        >{{ t+(index!=item.SpecialActivityList.length-1?'、':'') }}</span></template>
      </p>
      <p v-if="item.type==3">
        <template style="padding-left: 2px;"><span
          v-for="(t,index) in item.ActivityList"
          :key="index"
        >{{ t+(index!=item.ActivityList.length-1?'、':'') }}</span></template>
      </p>
    </div>
    <!-- 查看更多弹出框 -->
    <el-dialog
      :visible.sync="moreInfoDiag"
      :modal-append-to-body="false"
      title="商品列表"
    >
      <div style="overflow-y: scroll; padding: 10px; height: 300px;">
        <div>仅限购买:</div>
        <div>
          {{ infoList.map((i)=>{return i.SkuName}).join('、') }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { BaseMixin } from '../mixins/BaseMixin.js'
import Clickoutside from 'element-ui/src/utils/clickoutside'
export default {
  name: 'Coupon',
  directives: { Clickoutside },
  mixins: [BaseMixin],
  props: ['item', 'row'],
  data() {
    return {
      showDesc: false,
      moreInfoDiag: false,
      infoList: [],
      loading: false
    }
  },
  methods: {
    handleClose() {
      if (!this.row) { return }
      this.showDesc = false
    },
    handleCoupon(type, item) {
      // type:1 领取 2使用
      type === 1 ? this.$emit('handleDraw', item) : this.$emit('handleUse', item)
    },
    // 查看更多
    async moreInfoBtn(item) {
      this.loading = true
      const res = await this.getAction(
        '/api_coupon/Coupon/GetCouponGoods', { packageId: item.CouponPackageId ? item.CouponPackageId : item.Id }
      )
      if (res.IsSuccess) {
        this.loading = false
        this.infoList = res.Data[0].CouponPackageGoodsList
        this.moreInfoDiag = true
      } else {
        this.loading = false
        this.$toast.fail(res.Msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.coupon {
  position: relative;
  border: 1px solid #DFE1E8;
  border-radius: 2px;
  text-align: left;
  background: #FFFFFF;

  &:hover {
    border: 1px solid #0F6EE9;

    .rule-desc.absolute {
      border-right-color: #0F6EE9;
      border-bottom-color: #0F6EE9;
      border-left-color: #0F6EE9;
    }
  }

  .top {
    display: flex;

    &.border-bottom {
      border-bottom: 1px solid #EBEEF2;
    }
  }

  .left {
    width: 112px;
    height: 92px;
    background-position: 0 -1px;
    background-repeat: no-repeat;
    background-size: 112px 96px;
    background-image: url("../assets/coupon-normal.png");

    &.disabled {
      background-image: url("../assets/coupon-disabled.png");
    }

    &.completely {
      background-image: url("../assets/coupon-completely.png");
    }

    h3 {
      margin-top: 18px;
      text-align: center;

      strong {
        position: relative;
        height: 40px;
        font-size: 40px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 40px;

        em {
          position: absolute;
          right: -9px;
          bottom: 7px;
          display: block;
          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-size: 18px 18px;
          background-image: url("../assets/coupon-money.png");

          &.icon-disabled {
            background-image: url("../assets/coupon-money-disable.png");
          }

          &.icon-completely {
            background-image: url("../assets/coupon-money-completely.png");
          }

          &.icon-discount {
            background-image: url("../assets/coupon-discount.png");

            &.icon-discount-disabled {
              background-image: url("../assets/coupon-discount-disabled.png");
            }
          }
        }
      }
    }

    p {
      height: 12px;
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      color: #FFFFFF;
      line-height: 12px;
    }
  }

  .middle {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 12px;
    flex-direction: column;
    flex: 1;

    h5 {
      font-size: 14px;
      font-weight: 500;
      color: #111A34;
      line-height: 14px;

      span {
        display: inline-block;
        margin-right: 5px;
        border-radius: 4px;
        width: 44px;
        height: 16px;
        font-size: 12px;
        text-align: center;
        color: #FFFFFF;
        background: linear-gradient(328deg, #FF6831 0%, #F3180E 100%);
        line-height: 16px;
        vertical-align: middle;

        &.full-reduction {
          background:
            linear-gradient(
              328deg,
              #FF6831 0%,
              #F3180E 100%
            );
        }

        &.discount {
          background:
            linear-gradient(
              330deg,
              #4E9BFF 0%,
              #0F6EEA 100%
            );
        }

        &.disabled {
          background:
            linear-gradient(
              346deg,
              #858B9C 0%,
              #C5CAD5 100%
            );
        }
      }
    }

    .date {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
      color: #41485D;
      line-height: 12px;
    }

    .rule-show {
      font-size: 12px;
      color: #858B9C;
      line-height: 12px;

      .icon {
        display: inline-block;
        margin-left: 5px;
        width: 11px;
        height: 11px;
        font-size: 12px;
        color: #858B9C;
        line-height: 11px;
        vertical-align: middle;
      }
    }

    .tag-icon {
      position: absolute;
      top: 0;
      right: -10px;
      width: 62px;
      height: 47px;
    }
  }

  .right {
    z-index: 2;
    display: flex;
    justify-content: center;
    width: 30px;
    text-align: center;
    background: #0F6EE9;
    vertical-align: middle;
    cursor: pointer;

    &.isUse {
      background: #61B0FF;

      &:hover {
        background: #3690F7;
      }
    }

    &.disabled {
      color: #FFFFFF;
      background: #C5CAD5;

      &:hover {
        background: #C5CAD5;
      }
    }

    span {
      width: 15px;
      font-size: 12px;
      font-weight: 500;
      color: #FFFFFF;
      align-self: center;
      line-height: 16px;
    }

    &:hover {
      background: #0250C4;

      span {
        color: #FFFFFF;
      }
    }
  }

  .rule-desc {
    padding: 12px;
    font-size: 12px;
    text-align: left;
    color: #858B9C;
    line-height: 16px;

    &.absolute {
      position: absolute;
      top: 92px;
      right: -1px;
      left: -1px;
      z-index: 3;
      border: 1px solid #DFE1E8;
      background: #FFFFFF;
    }

    p {
      margin-bottom: 5px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
